import { useSetAtom } from "jotai";
import {ConfirmModalAtom} from "../utils/atoms";

const useConfirm = () => {
  const setDialog = useSetAtom(ConfirmModalAtom);

  const confirm = (title, message, confirmText = "Yes", cancelText = "No", confirmStyle = {}, cancelStyle = {}) =>
    new Promise((resolve) => {
      setDialog({
        open: true,
        title,
        message,
        confirmText,
        cancelText,
        confirmStyle,
        cancelStyle,
        resolve,
      });
    });

  return confirm;
};

export default useConfirm;
